import type { MembersTableSortBy } from '@/store/api/userApi';

export const getSortableField = (header: string): MembersTableSortBy | null => {
  const lowerCaseHeader = header.toLowerCase().replaceAll(' ', '');

  switch (lowerCaseHeader) {
    case 'name':
      return 'name';
    case 'joined':
      return 'joined_at';
    case 'coach':
      return 'coach_name';
    case 'contractend':
      return 'contract_end_date';
    case 'enddatestatus':
      return 'end_date_status';
    case 'seattype':
      return 'seat_type';
    case 'adminnote':
      return 'admin_note';
    case 'sessions':
      return null;
    case 'status':
      // Prefer sorting by human-readable status label once backend supports it.
      // Fallback remains to member_status until member_status_text is available.
      return 'member_status';
    case 'insightsstatus':
      return 'insights_status';
    default:
      return null;
  }
};
